/**
 * #flair.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../typeRegistry.js";
function createBaseLinkFlairV2() {
    return { text: "", cssClass: "", backgroundColor: "", templateId: "", textColor: "" };
}
export const LinkFlairV2 = {
    $type: "devvit.reddit.v2alpha.LinkFlairV2",
    encode(message, writer = _m0.Writer.create()) {
        if (message.text !== "") {
            writer.uint32(10).string(message.text);
        }
        if (message.cssClass !== "") {
            writer.uint32(18).string(message.cssClass);
        }
        if (message.backgroundColor !== "") {
            writer.uint32(26).string(message.backgroundColor);
        }
        if (message.templateId !== "") {
            writer.uint32(34).string(message.templateId);
        }
        if (message.textColor !== "") {
            writer.uint32(42).string(message.textColor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLinkFlairV2();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.cssClass = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.backgroundColor = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.templateId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.textColor = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            cssClass: isSet(object.cssClass) ? globalThis.String(object.cssClass) : "",
            backgroundColor: isSet(object.backgroundColor) ? globalThis.String(object.backgroundColor) : "",
            templateId: isSet(object.templateId) ? globalThis.String(object.templateId) : "",
            textColor: isSet(object.textColor) ? globalThis.String(object.textColor) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.cssClass !== "") {
            obj.cssClass = message.cssClass;
        }
        if (message.backgroundColor !== "") {
            obj.backgroundColor = message.backgroundColor;
        }
        if (message.templateId !== "") {
            obj.templateId = message.templateId;
        }
        if (message.textColor !== "") {
            obj.textColor = message.textColor;
        }
        return obj;
    },
    create(base) {
        return LinkFlairV2.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLinkFlairV2();
        message.text = object.text ?? "";
        message.cssClass = object.cssClass ?? "";
        message.backgroundColor = object.backgroundColor ?? "";
        message.templateId = object.templateId ?? "";
        message.textColor = object.textColor ?? "";
        return message;
    },
};
messageTypeRegistry.set(LinkFlairV2.$type, LinkFlairV2);
function createBaseUserFlairV2() {
    return {
        userId: "",
        subredditId: "",
        text: "",
        cssClass: "",
        templateId: "",
        textColor: "",
        backgroundColor: "",
        enabled: false,
    };
}
export const UserFlairV2 = {
    $type: "devvit.reddit.v2alpha.UserFlairV2",
    encode(message, writer = _m0.Writer.create()) {
        if (message.userId !== "") {
            writer.uint32(10).string(message.userId);
        }
        if (message.subredditId !== "") {
            writer.uint32(18).string(message.subredditId);
        }
        if (message.text !== "") {
            writer.uint32(26).string(message.text);
        }
        if (message.cssClass !== "") {
            writer.uint32(34).string(message.cssClass);
        }
        if (message.templateId !== "") {
            writer.uint32(42).string(message.templateId);
        }
        if (message.textColor !== "") {
            writer.uint32(50).string(message.textColor);
        }
        if (message.backgroundColor !== "") {
            writer.uint32(58).string(message.backgroundColor);
        }
        if (message.enabled !== false) {
            writer.uint32(64).bool(message.enabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserFlairV2();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.userId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.subredditId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.cssClass = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.templateId = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.textColor = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.backgroundColor = reader.string();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.enabled = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
            subredditId: isSet(object.subredditId) ? globalThis.String(object.subredditId) : "",
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            cssClass: isSet(object.cssClass) ? globalThis.String(object.cssClass) : "",
            templateId: isSet(object.templateId) ? globalThis.String(object.templateId) : "",
            textColor: isSet(object.textColor) ? globalThis.String(object.textColor) : "",
            backgroundColor: isSet(object.backgroundColor) ? globalThis.String(object.backgroundColor) : "",
            enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== "") {
            obj.userId = message.userId;
        }
        if (message.subredditId !== "") {
            obj.subredditId = message.subredditId;
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.cssClass !== "") {
            obj.cssClass = message.cssClass;
        }
        if (message.templateId !== "") {
            obj.templateId = message.templateId;
        }
        if (message.textColor !== "") {
            obj.textColor = message.textColor;
        }
        if (message.backgroundColor !== "") {
            obj.backgroundColor = message.backgroundColor;
        }
        if (message.enabled !== false) {
            obj.enabled = message.enabled;
        }
        return obj;
    },
    create(base) {
        return UserFlairV2.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserFlairV2();
        message.userId = object.userId ?? "";
        message.subredditId = object.subredditId ?? "";
        message.text = object.text ?? "";
        message.cssClass = object.cssClass ?? "";
        message.templateId = object.templateId ?? "";
        message.textColor = object.textColor ?? "";
        message.backgroundColor = object.backgroundColor ?? "";
        message.enabled = object.enabled ?? false;
        return message;
    },
};
messageTypeRegistry.set(UserFlairV2.$type, UserFlairV2);
function isSet(value) {
    return value !== null && value !== undefined;
}
